import { IDataShape } from '../models/dataShape'
import { TItemsMap } from '../models/other'

export const getItemsMap = (data: IDataShape[]): TItemsMap => {
  return data.reduce((acc, item, currentIndex) => {
    return {
      ...acc,
      [item.itemId]: currentIndex,
    }
  }, {} as TItemsMap)
}
